module.exports = __webpack_public_path__ + "img/miles-box.3a8970eb.png";